import React from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { observer } from "mobx-react";

import TeamStandings from "./TeamStandings";

export default observer(function TeamStandingsStatistics(props: {
	isSettingsDrawerOpen: boolean;
	onClose: (value: boolean) => void;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store?.displayStatisticsGroup === StatisticsGroups.TeamStandings) {
		return (
			<ErrorBoundaryWithPropagation componentName="Mobile/TeamStandingsStatistics.tsx">
				<TeamStandings
					isSettingsDrawerOpen={props.isSettingsDrawerOpen}
					onClose={props.onClose}
					store={store}
				/>
			</ErrorBoundaryWithPropagation>
		);
	}
	return null;
});
